import { createStore, applyMiddleware } from 'redux'
import {createLogger} from 'redux-logger';
import Immutable from 'immutable';
import rootReducer from '../reducers'
import ReduxThunk  from 'redux-thunk'

const initialState = Immutable.Map();

const middlewares = [ReduxThunk];

if (process.env.NODE_ENV === `development`) {
    middlewares.push(createLogger({ stateTransformer: state => state.toJS()}))
}

export default createStore(
    rootReducer,
    initialState,
    applyMiddleware(...middlewares)
);

